import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const steps = [
  { num: "01", label: "LEARN THE SKILL", mobileLabel: "LEARN", desc: "Frameworks, scripts, structures", mobileDesc: "Frameworks, scripts, structure" },
  { num: "02", label: "GET SHARP", mobileLabel: "GET SHARP", desc: "1-on-1 calls, AI trainer, network", mobileDesc: "Calls, AI trainer, network" },
  { num: "03", label: "STEP INTO OFFERS", mobileLabel: "STEP IN", desc: "Daily placement, real closes", mobileDesc: "Placement, real closes" },
];

const ease = [0.22, 1, 0.36, 1] as const;

const FloorPath = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <section ref={ref} className="relative overflow-hidden" style={{ background: "hsl(0 0% 4.5%)" }}>
      {/* Trace line — driven by native scroll-timeline (CSS), no JS scroll listener */}
      <div
        className="h-px scroll-trace"
        style={{
          background: "linear-gradient(90deg, hsl(42 80% 52% / 0.5), hsl(42 80% 52% / 0.15))",
        }}
      />

      <div className="px-6 md:px-12 lg:px-20 py-0">
        <div className="max-container">
          <div className="grid grid-cols-1 md:grid-cols-3">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 14 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.1 + i * 0.12, ease }}
                className="relative py-5 md:py-7 px-0 md:px-6 first:pl-0 last:pr-0"
              >
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="relative mt-1.5">
                    <motion.div
                      className="w-1.5 h-1.5 bg-primary/40 rounded-full"
                      initial={{ scale: 0 }}
                      animate={inView ? { scale: 1 } : {}}
                      transition={{ duration: 0.3, delay: 0.25 + i * 0.15, ease }}
                    />
                  </div>
                  <div>
                    <span className="font-display text-[10px] tracking-[0.3em] text-primary/50 font-bold">{step.num}</span>
                    <h2 className="hidden md:block font-display text-sm font-bold text-foreground/85 tracking-[0.04em] mb-0.5 leading-[1.3]">{step.label}</h2>
                    <h2 className="md:hidden font-display text-[13px] font-bold text-foreground/85 tracking-[0.04em] mb-0.5 leading-[1.3]">{step.mobileLabel}</h2>
                    <p className="hidden md:block text-foreground/40 text-[13px] font-light tracking-wide leading-relaxed">{step.desc}</p>
                    <p className="md:hidden text-foreground/40 text-[12px] font-light tracking-wide leading-relaxed">{step.mobileDesc}</p>
                  </div>
                </div>

                {i < steps.length - 1 && (
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-px h-8 hidden md:block" style={{ background: "linear-gradient(180deg, transparent, hsl(42 65% 48% / 0.12), transparent)" }} />
                )}
                <div className="absolute bottom-0 left-0 w-full h-px bg-border/40 md:hidden" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <div className="h-px w-full bg-gradient-to-r from-transparent via-border/60 to-transparent" />
    </section>
  );
};

export default FloorPath;
